import type { StaffCoordinationTechnicianResponse } from '@/types/apps/staff-coordination-technician.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface StaffCoordinationTechnicianServiceInterface {}

type StaffCoordinationTechnicianListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationTechnicianResponse>
>;

export class StaffCoordinationTechnicianService
    implements Indexable, Updatable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/staff-coordination',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationTechnicianListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public update(params: any): Promise<ApiResponse<any>> {
        return this.apiClient.postApi(this.endpoints.base(), params);
    }
}
